// What this visitor looked at lately, kept in this browser only (KALI-31). Storage can be
// missing, full or blocked, so every read and write is guarded and the page works without it.

function read(key: string): unknown[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(key) ?? "[]");
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

/** Puts `item` first, drops an older copy of it, and keeps the newest `limit`. */
function remember<T>(key: string, item: T, limit: number, valid: (value: unknown) => value is T) {
  const kept = [item, ...read(key).filter(valid).filter((value) => value !== item)].slice(0, limit);
  try {
    localStorage.setItem(key, JSON.stringify(kept));
  } catch {
    // Not remembered this time; nothing else depends on it.
  }
}

const isId = (value: unknown): value is number => Number.isInteger(value) && (value as number) > 0;
const isText = (value: unknown): value is string => typeof value === "string" && value.trim() !== "";

/** Listing ids, newest first. The server asks for at most 12. */
export const recentlyViewed = {
  list: () => read("kalikaya.recentlyViewed").filter(isId),
  add: (id: number) => remember("kalikaya.recentlyViewed", id, 12, isId),
};

/** Searches typed, newest first. */
export const recentSearches = {
  list: () => read("kalikaya.recentSearches").filter(isText),
  add: (query: string) => remember("kalikaya.recentSearches", query, 3, isText),
};
